<template>
    <Card :title="$t('labels.filter_item')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6" v-for="languageAlias in languageAliasesByFilterType">
                    <FormGroup :label="`${$t('labels.name')} (${$t(`languages.${languageAlias}`)})`">
                        <template v-if="filter?.source_id === null || (filter?.source_id !== null && filter?.allow_custom_values)">
                            <Input
                                :model-value="filterItem.names?.[languageAlias]"
                                @update:model-value="filterItem.names[languageAlias] = $event"
                                :type="filter?.type === 'number' ? 'number' : 'text'"
                            />
                            <span v-if="filter?.type === 'number' && (filter?.min_number_value !== null || filter?.max_number_value !== null)" class="form-text text-muted">
                                <span v-if="filter?.min_number_value !== null">
                                    {{ $t('labels.min') }}: {{ filter?.min_number_value }}
                                </span>
                                <span v-if="filter?.max_number_value !== null">
                                    <span v-if="filter?.min_number_value !== null"> - </span>
                                    {{ $t('labels.max') }}: {{ filter?.max_number_value }}
                                </span>
                            </span>
                        </template>
                        <template v-else>
                            <Autocomplete
                                @update:model-value="newFilterItem => selectFilterItem(newFilterItem, languageAlias)"
                                :model-value="filterItem.names[languageAlias]"
                                :selected-value="filterItem.names[languageAlias]"
                                :url="`/projects/${$route.params.projectUuid}/marketplace/sources/${integration.service}/categories/${category?.source_id}/attributes/${filter?.source_id}/items`"
                                :query-params="{
                                    category_parent_id: category?.parent_source_id,
                                    orders: [{column: `name_${languageAlias}`, dir: 'asc'}]
                                }"
                                option-key="source_id"
                                :option-value="`name_${languageAlias}`"
                                :not-found-alert-texts="{
                                    category: $t('alerts.marketplace_category_not_found'),
                                    attribute: $t('alerts.marketplace_attribute_not_found')
                                }"
                            />
                        </template>
                    </FormGroup>
                </div> 
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button color="indigo" @click="create">
                {{ translate('buttons.create') }}
            </Button>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../components/new/form/Input.vue";
import Button from "../../../../components/new/button/AppButton.vue";
import Autocomplete from "../../../../components/new/form/autocomplete/AppAutoComplete.vue";
import Alert from "../../../../components/AlertComponent.vue";

import { httpClient } from "../../../../services/HttpClient";
import MessageNotificator from "../../../../services/MessageNotificator";

export default {
    name: "CreateFilterItemCard",
    components: {
        Card, FormGroup, Input, Button, Autocomplete, Alert
    },
    props: {
        integration: {
            type: Object
        }
    },
    data() {
        return {
            filterItem: {
                names: {}
            },
            sourceId: null,
            category: null,
            filter: null
        }
    },
    methods: {
        async create() {
            let requestData = {
                integration_filter_uuid: this.$route.params.filterUuid
            };

            if (this.filter?.type === 'number') {
                requestData.names = {}

                for (let languageAlias of this.integration.language_aliases) {
                    requestData.names[languageAlias] = this.filterItem.names[languageAlias] || this.filterItem.names[this.mainLanguageAlias] || '';
                }
            } else {
                requestData.names = this.filterItem.names
            }

            if (this.sourceId !== null) {
                requestData.source_id = this.sourceId
            }

            await httpClient.post(`/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/filter-items`, requestData).then(() => {
                this.$router.replace({
                    name: "EditIntegrationFilterCard"
                })
                new MessageNotificator().success(this.$t("alerts.success"))
            })
        },
        selectFilterItem(filterItem) {
            this.integration.language_aliases.forEach(lang => {
                if (!filterItem[`name_${lang}`]) {
                    return
                }
                
                this.filterItem.names[lang] = filterItem[`name_${lang}`]
            })
            this.sourceId = filterItem.source_id
        },
        async fetchCategory() {
            await httpClient.get(`/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/categories/${this.$route.params.categoryUuid}`).then((response) => {
                this.category = response.data.data
            })
        },
        async fetchFilter() {
            await httpClient.get(`/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/filters`, {
                uuids: [this.$route.params.filterUuid]
            }).then((response) => {
                this.filter = response.data.data[0]
            })
        }
    },
    computed: {
        mainLanguageAlias() {
            return this.integration.language_aliases[0];
        },
        languageAliasesByFilterType() {
            return this.filter?.type === 'number' ? [this.mainLanguageAlias] : this.integration.language_aliases;
        }
    },
    async mounted() {
        await this.fetchCategory()
        await this.fetchFilter()
    }
}
</script>